// Voice Input (speech-to-text) client — the reusable dictation capability.
//
// Deliberately SEPARATE from danaVoiceApi: this hits the STT-only
// /ai/voice/transcribe route (audio in → text out, no Dana turn), so any text
// field can dictate without the dana_voice entitlement. Same cookie-session
// auth + silent-refresh as every other client.
import { withAuth } from './hrApi';

const client = withAuth(import.meta.env.VITE_AI_URL || 'http://localhost:8001');
client.defaults.timeout = 45000; // upload + STT

export interface TranscribeResult {
  text: string;
  detectedLanguage?: string | null;
  durationMs?: number | null;
  provider?: string;
}

export interface TranscribeOptions {
  /** IETF locale hint (e.g. "en-KE", "sw"). Provider still auto-detects
   *  mixed EN/SW — this only nudges. */
  locale?: string;
  /** Client-measured clip length; the provider exposes none. */
  durationMs?: number;
}

export const transcribeAudio = (
  blob: Blob,
  mime: string,
  opts: TranscribeOptions = {},
): Promise<TranscribeResult> => {
  const form = new FormData();
  form.append('audio', blob, mime.includes('webm') ? 'clip.webm' : 'clip.m4a');
  const locale = opts.locale || localStorage.getItem('preferred-locale') || undefined;
  if (locale) form.append('locale', locale);
  if (opts.durationMs && opts.durationMs > 0) {
    form.append('duration_ms', String(Math.round(opts.durationMs)));
  }
  return client.post('/api/v1/ai/voice/transcribe', form).then((r) => r.data as TranscribeResult);
};
